import React from 'react';
import './CoursePage.css';
import MyFooter from './MyFooter';
import {useNavigate } from 'react-router-dom';

const CoursePage = () => {
  const Navigate = useNavigate();
  const handleApply = () => {
  
    // You can replace this with actual application logic
    //window.location.href = "mailto:capermanjeri@gmail.com?subject=Application for Palliative Care Foundation Course";
    Navigate('/palliativecareform');
  };
  
  return (
    <div data-aos="fade-up" className="course-page">
      <div className="header-section">
        <div className="header-content">
          <div className="logo-section">
            <h1>CDPC</h1>
            <p>The Centre for Development Studies in Community Palliative Care (CDPC), the training and research arm of CAPCA, offers a variety of palliative care courses tailored for medical and allied professionals, volunteers, patients' relatives, and the general public.</p>
          </div>
          <div className="course-title">
            <h2>10 DAYS</h2>
            <h1>Palliative Care Foundation Course</h1>
            <h3>For Doctors</h3>
          </div>
        </div>
      </div>

      <div className="main-content">
        <div className="image-section">
          <img src="./PFC-Course.jpg" alt="Palliative Care Foundation Course" />
        </div>

        <div className="course-details">
          

          <div className="details-section">
            <h2>Course Details</h2>
            <ul>
              <li><strong>Duration:</strong> 10 days</li>
              <li><strong>Eligibility:</strong> MBBS/BDS</li>
              <li><strong>Venue:</strong> Cherani Palliative Care Clinic, Karuvambram, Manjeri-676123</li>
              <li><strong>Course Fee:</strong> ₹5000</li>
            </ul>
          </div>

          <div className="requirements-section">
            <h2>Program Requirements</h2>
            <ul>
              <li>Participants must complete home care visits during the course duration</li>
              <li>Practical hands-on training in palliative care techniques</li>
              <li>Case discussions and interactive sessions</li>
            </ul>
          </div>

          <div className="apply-section">
            {/* <h2>How to Apply</h2>
            <p>Send your CV to <a href="mailto:capermanjeri@gmail.com">capermanjeri@gmail.com</a></p>
            <p>Phone: <a href="tel:9605767367">9605767367</a></p>
            <p><strong>Last Date:</strong> 10th February 2025</p> */}
            <button onClick={handleApply} className="apply-button">Apply Now</button>
          </div>
        </div>
      </div>

      <div className="footer">
        <p>© {new Date().getFullYear()} CDPC - Centre for Development Studies in Community Palliative Care</p>
        <p>Cherani Palliative Care Clinic, Karuvambram, Manjeri-676123</p>
      </div>
     
    </div>
  );
};

export default CoursePage;